export const SIDES = {
  TOP: 'top',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  LEFT: 'left',
} as const;

export const PLACEMENTS = {
  ...SIDES,
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
} as const;

export const VARIANTS = {
  LIGHT: 'light',
  MEDIUM: 'medium',
  DARK: 'dark',
} as const;
